import { module as BaseModule } from 'modujs'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { gsap } from 'gsap'

export default class extends BaseModule {
  init() {
    this.reveal()
    this.anchors()
    this.frontpage()
  }

  reveal() {
    const logo = document.querySelector('#logo')
    const header = this.el

    gsap.fromTo(
      [header, logo],
      {
        opacity: 0,
        y: 20,
      },
      {
        opacity: 1,
        y: 0,
        duration: 1,
        delay: 0.5,
      },
    )
  }

  anchors() {
    this.anchorings = this.el.querySelectorAll('[data-navigation-anchor]')
    this.anchorings.forEach((anchor, index) => {
      const { navigationAnchor } = anchor.dataset

      anchor.addEventListener('click', (e) => {
        e.preventDefault()
        window.lenis.scrollTo(`#${navigationAnchor}`)
      })

      const section = document.querySelector(`#${navigationAnchor}`)
      if (!section) return

      const { viewportStart } = section.dataset
      const { viewportEnd } = section.dataset

      ScrollTrigger.create({
        trigger: section,
        start: viewportStart,
        end: viewportEnd,
        onEnter: () => {
          this.anchorings.forEach((element, i) => {
            element.classList.toggle('is-active', i === index)
          })
        },
        onEnterBack: () => {
          this.anchorings.forEach((element, i) => {
            element.classList.toggle('is-active', i === index)
          })
        },
      })
    })
  }

  frontpage() {
    const frontpage = document.querySelector(
      '.template-frontpage, [data-class-injection="template-frontpage"]',
    )

    if (!frontpage) return

    const logo = document.querySelector('#logo')
    const headerBg = document.querySelector('#header-bg')
    document.addEventListener('grain', ({ detail }) => {
      const { active } = detail
      logo.classList.toggle('mix-blend-difference', active)
      headerBg.style.background = active ? '#000' : '#fff'
    })
  }
}
